import { Card, CardBody, Col, Row } from "reactstrap";
import { H4, P } from "../../../AbstractElements";
import { ARTICAL_AND_VIDEO_3 } from "../../../Data/Knowledgebase";

const ArticalAndVideo3 = () => {
  return (
    <Col xl="4">
      <Row>
        {ARTICAL_AND_VIDEO_3.map((item, i) => (
          <Col xl="12" md={item.md} key={i}>
            <Card>
              <CardBody>
                <div className="d-flex">
                  {item.iconClass}
                  <div className="flex-grow-1">
                    <H4 className="f-w-700">{item.title}</H4>
                    <P>{item.description}</P>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default ArticalAndVideo3;
